(function ($) {
  'use strict';

  Drupal.behaviors.gutenbergFix = {
    attach: function (context, settings) {
      $('.wp-block-group:not(.gutenberg-fix-processed)', context)
        .addClass('gutenberg-fix-processed')
        .each(function () {
          var $group = $(this);
          var $innerContainer = $group.children('.wp-block-group__inner-container');

          if (!$innerContainer.length) {
            $group.wrapInner('<div class="wp-block-group__inner-container"></div>');
          }
        });
    },
  };
})(jQuery);
